import { createContext } from 'react';
import type { CurrentCustomerType } from './types';

const CurrentCustomer = createContext<CurrentCustomerType>(
  {} as CurrentCustomerType,
);

export default CurrentCustomer;
